import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { statesDataAutomation } from "app/pages/activation/components/ProjectsList/dataAutomationKeys";

import { EMPTY_STATE_BANNER_IMAGE } from "./constants";
import * as SC from "./styles";
import { EMPTY_STATE_BANNER_BTN_TEXT, EMPTY_STATE_BANNER_SUB_TITLE_TEXT, EMPTY_STATE_BANNER_TITLE_TEXT } from "./texts";

type EmptyStateBannerSchema = {
    onClick: () => void;
};

export const EmptyStateBanner = ({ onClick }: EmptyStateBannerSchema) => (
    <SC.BannerWrapper data-automation={statesDataAutomation.empty}>
        <SC.ContentContainer>
            <SC.BannerTitle>{translate(EMPTY_STATE_BANNER_TITLE_TEXT)}</SC.BannerTitle>
            <SC.BannerSubTitle>{translate(EMPTY_STATE_BANNER_SUB_TITLE_TEXT)}</SC.BannerSubTitle>
            <SC.ButtonWrapper>
                <Button
                    onClick={onClick}
                    type="primary"
                >
                    {translate(EMPTY_STATE_BANNER_BTN_TEXT)}
                </Button>
            </SC.ButtonWrapper>
        </SC.ContentContainer>
        <SC.ImageWrapper>
            <SC.BannerImage src={AssetsService.assetUrl(EMPTY_STATE_BANNER_IMAGE)} />
        </SC.ImageWrapper>
    </SC.BannerWrapper>
);
